import React from "react";
import { Checkbox } from "../../ui/checkbox";
import { cn } from "../../../lib/utils";

/**
 * Single confirmation checkbox. The prompt is the label.
 * When required, the box must be checked to proceed.
 *
 * @param {Object} props
 * @param {object} props.question
 * @param {boolean} [props.value]
 * @param {function(boolean, {{ immediate?: boolean }}): void} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.readOnly]
 * @param {boolean} [props.showRequired]
 * @returns {JSX.Element}
 */
export default function CheckboxQuestion({
  question,
  value,
  onChange,
  error,
  readOnly,
  showRequired,
}) {
  const fieldId = `survey-q-${question.id}`;
  const checked = value === true;
  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor={fieldId}
        className={cn(
          "flex items-start gap-3 rounded-md py-1",
          readOnly ? "cursor-default" : "cursor-pointer"
        )}
      >
        <Checkbox
          id={fieldId}
          checked={checked}
          disabled={readOnly}
          onCheckedChange={(next) => onChange(next === true, { immediate: true })}
          className="mt-0.5 h-5 w-5"
        />
        <span className="text-sm text-text-primary">
          {question.prompt}
          {showRequired ? (
            <span className="ml-1 text-error" aria-hidden>
              *
            </span>
          ) : null}
        </span>
      </label>
      {question.helpText ? (
        <p className="pl-8 text-sm text-text-secondary">{question.helpText}</p>
      ) : null}
      {error ? (
        <p className="pl-8 text-sm text-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
